@if (!store.loaded()) {
  <div class="banks-view__loading" role="status" aria-label="Carregando os bancos">
    <app-cog-loading-spinner [size]="56" />
  </div>
} @else if (!store.unlocked()) {
  <!-- Só se chega aqui pela URL (?view=banks): sem banco, o seletor da faixa fica travado. -->
  <div class="banks-view__empty">
    <i class="pi pi-building-columns" aria-hidden="true"></i>
    <strong>Nenhum dos seus deals tem banco ainda</strong>
    <p>
      Os bancos aparecem aqui quando a Legatus vincula a primeira operação a um dos seus deals.
      Volte para Jornada dos deals para acompanhar as etapas de cada deal.
    </p>
  </div>
} @else {
  <div class="banks-view__filters">
    <app-select
      class="banks-view__filter banks-view__filter--deal"
      [theme]="'medium'"
      [placeholder]="'Empresa / deal: todos'"
      [selectedItemsLabel]="'{0} deals'"
      [multiple]="true"
      [maxSelectedLabels]="1"
      [options]="dealOptions()"
      [hasFilter]="dealOptions().length > 6"
      [ngModel]="store.dealFilter()"
      (ngModelChange)="store.dealFilter.set($event ?? [])" />

    <app-select
      class="banks-view__filter"
      [theme]="'medium'"
      [placeholder]="'Banco: todos'"
      [selectedItemsLabel]="'{0} bancos'"
      [multiple]="true"
      [maxSelectedLabels]="1"
      [options]="bankOptions()"
      [hasFilter]="bankOptions().length > 6"
      [ngModel]="store.bankFilter()"
      (ngModelChange)="store.bankFilter.set($event ?? [])" />

    @if (store.dealFilter().length || store.bankFilter().length) {
      <app-button
        label="Limpar filtros"
        icon="pi pi-times"
        theme="link"
        size="small"
        [noMargin]="true"
        [type]="'button'"
        (sendButtonClick)="store.dealFilter.set([]); store.bankFilter.set([])" />
    }
  </div>

  <section class="banks-view__summary">
    <app-deal-bank-journey-summary
      heading="Jornada nos bancos · todos os deals"
      [showDealCount]="true" />
  </section>

  @if (store.cards().length === 0) {
    <div class="banks-view__empty banks-view__empty--filter">
      <i class="pi pi-filter-slash" aria-hidden="true"></i>
      <strong>Nenhum banco com esses filtros</strong>
      <p>Troque a empresa, o banco ou a busca, ou limpe os filtros para ver todos os bancos.</p>
    </div>
  } @else {
    <app-deal-bank-journey-tab [showDeal]="true" />
  }
}

<!-- Comentários de um banco: o mesmo painel de dentro do deal, que já mostra a empresa e o número do deal. -->
<app-bank-journey-comments-drawer
  [card]="store.selectedCard()"
  (closed)="store.closeComments()"
  (commented)="store.reload()" />
